import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
import apiClient from "../lib/api";
import urlConstant from "../constants/urlConstants";

const StateField = ({
  formData,
  onChange,
  rawErrors = [],
  idSchema,
  schema,
  required, // <-- Add this
}) => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await apiClient.get(urlConstant.State.GetAllStates);
        if (Array.isArray(response.data)) {
          setStates(response.data); // expects: [{ id, stateName }]
        }
      } catch (err) {
        console.error("Failed to fetch states:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, []);

  return (
    <FormControl fullWidth error={rawErrors.length > 0}>
      <TextField
        id={idSchema?.$id}
        select
        label={
          schema?.title
            ? `${schema.title}${required ? " *" : ""}`
            : `State${required ? " *" : ""}`
        }
        value={formData || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        error={rawErrors.length > 0}
      >
        {states.map((state) => (
          <MenuItem key={state.id} value={state.stateName}>
            {state.stateName}
          </MenuItem>
        ))}
      </TextField>
      {rawErrors.length > 0 && (
        <FormHelperText>{rawErrors[0]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default StateField;
